import React from 'react';
import { useSectionAnimation } from '../hooks/useSectionAnimation';

const AnimatedSection = ({ children, className = "", style = {} }) => {
  const { ref, isVisible } = useSectionAnimation();

  const combinedClassName = `
    transition-all duration-1000 ease-in-out
    ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}
    ${className}
  `;

  return (
    <div
      ref={ref}
      className={combinedClassName.trim()}
      style={style}
    >
      {children}
    </div>
  );
};

export default AnimatedSection;